import styled from 'styled-components'

export const InfoMessageWrapper = styled.div`
  border: 1px solid #aabffb;
  border-radius: 6px;
  background-color: #f4f7fe;
  padding: 24px;
`

export const InfoMessageTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`
